export default {"src":"/_next/static/media/BTC.21b7fd01.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};